"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconChargingServicesForHousingAssociation = function IconChargingServicesForHousingAssociation(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "m13.763 4.943 1.414 1.414-1.854 1.855 1.34 1.34 1.82-1.82 1.414 1.415-1.82 1.82 1.403 1.403-2.524 2.524a5 5 0 0 1-5.954.838 2.64 2.64 0 0 0 .343 2.917l.142.154-.812.812.812-.812 4.14 4.14-.01.01a3.91 3.91 0 0 1 0 5.533 3.91 3.91 0 0 1-5.374.153l-.16-.153-5.97-5.969 1.414-1.414 5.97 5.97-.768.768.769-.767a1.91 1.91 0 0 0 2.706-.002 1.91 1.91 0 0 0 .114-2.58l-.114-.124.697-.7-.688.69-4.14-4.14a4.64 4.64 0 0 1-.613-5.808 5 5 0 0 1 .425-6.587l2.11-2.11h.83l1.084 1.084zm-3.354 3.184 4.242 4.242-1.11 1.11a3 3 0 0 1-4.118.118l-.144-.137a2.99 2.99 0 0 1-.859-2.102 3 3 0 0 1 .88-2.121zm5.55 11.019 8.064 7.685 8.601 1.37a3.1 3.1 0 0 1 1.926 1.107l.127.167a3.1 3.1 0 0 1 .547 2.151l-.03.206-.86 4.629a3.1 3.1 0 0 1-2.868 2.534L31.28 39H27.9a5.002 5.002 0 0 1-9.8 0H7v-2h11.1a5.002 5.002 0 0 1 9.8 0h3.382a1.1 1.1 0 0 0 1.056-.784l.029-.119.86-4.63a1.1 1.1 0 0 0-.79-1.263l-.124-.027-9.218-1.468-8.515-8.115zM26 38a3 3 0 1 0-6 0 3 3 0 0 0 6 0m-3-1.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m0 1a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1M16 35v1h-5v-1zm9.777-26.009-7.847 8.145 1.44 1.388 6.412-6.656L33 19.305V26h2v-7.506zm2.393.805 2.608-2.704L40 16.595V34h-4v-2h2V17.405l-7.218-7.437-1.172 1.216zm7.608-4.704L33.17 7.796l1.44 1.388 1.172-1.216L43 15.405V30h-2v2h4V14.595z",
    clipRule: "evenodd"
  })));
};

export { IconChargingServicesForHousingAssociation, IconChargingServicesForHousingAssociation as default };
